import classNames from 'classnames'
import type {ReactNode} from 'react'

import styles from './AgentsLink.css'

export const calculateContent = (
  agentsNum = 0,
  freeAgentsNum: number | null | undefined = null,
  licensedConcurrentBuilds = 0,
) => {
  let agentsLoad = 0
  let title: ReactNode = `Total: ${agentsNum}`

  if (freeAgentsNum != null) {
    const workingAgentsNum = agentsNum - freeAgentsNum

    if (workingAgentsNum > 0 || freeAgentsNum > 0) {
      agentsLoad = workingAgentsNum / agentsNum
    }

    if (agentsLoad < 0) {
      agentsLoad = 1
    }

    const idle = freeAgentsNum < 0 ? 0 : freeAgentsNum

    if (agentsNum > 0) {
      title = (
        <>
          {title}
          <br />
          {`Idle: ${idle}`}
          <br />
          {`Busy: ${workingAgentsNum}`}
        </>
      )
    }
  }

  title = (
    <>
      <span className={styles.heading}>{'Agents'}</span>
      {title}
      <span className={classNames(styles.heading, styles.builds)}>{'Builds'}</span>
      {`Running: ${licensedConcurrentBuilds}`}
    </>
  )

  return {
    agentsLoad,
    title,
  }
}
